import React from "react";
import InterestContainer from "./InterestContainer";
import emblemDark from "../../assets/emblem_dark.svg";
import { useTranslation } from "react-i18next";

const InterestsInitial = () => {
    const { t } = useTranslation();
    return (
        <InterestContainer 
            title={t('interests.initial.title')}
            description={t('interests.initial.description')}
            image={emblemDark}
            initial
        />
    );
};

export default InterestsInitial;